import React, { useState, useEffect } from "react";
import "../styles/stocklist.scss";
import {
  Input,
  Flex,

  Divider,
  Text,
  Spacer,
} from "@chakra-ui/react";
import { Col, Row } from "reactstrap";
import { isEmpty } from "lodash";

const StockVariantCard = ({
  variant,
}) => {

  const [variantState, setVariantState] = useState({});


  useEffect(() => {
    if (!isEmpty(variant.productVariant)) {
      setVariantState({ ...variant });
    }
  }, [variant]);

  return (
    <Flex justify="space-between" align="center">
      <div
        className="input-wrapper"
        style={{
          width: "20%",
          padding: "32px",
          borderRight: "1px solid #C4C4C4",
        }}>
        {variant.productVariant.name}
      </div>
      <Divider orientation="vertical" width="1px" />
      <div
        className="input-wrapper"
        style={{
          width: "10%",
          padding: "32px",
          borderRight: "1px solid #C4C4C4",
        }}>
        {(variant?.availableStock || 0) === 0
          ? "Out of Stock"
          : (variant?.availableStock || 0) < (variant?.minSafetyStock || 0)
          ? "Low Stock"
          : "Ready Stock"}
      </div>
      <div className="input-wrapper" style={{ width: "60%", padding: "16px" }}>
        <Row>
          <Col xl={6}>
            <Col xl={12} style={{ padding: "8px" }}>
              <Flex align="center">
                <Text>Available Stock</Text>
                <Spacer />
                <Input
                  disabled
                  value={variantState?.availableStock || 0}
                />
              </Flex>
            </Col>
            <Col xl={12} style={{ padding: "8px" }}>
              <Flex align="center">
                <Text>Min Safety Stock</Text>
                <Spacer />
                <Input
                  disabled
                  value={variantState?.minSafetyStock || 0}
                />
              </Flex>
            </Col>
          </Col>
          <Col xl={6}>
            <Col xl={12} style={{ padding: "8px" }}>
              <Flex align="center">
                <Text>Reserved Stock</Text>
                <Spacer />
                <Input disabled value={variantState?.reservedStock || 0} />
              </Flex>
            </Col>
            <Col xl={12} style={{ padding: "8px" }}>
              <Flex align="center">
                <Text>QC Stock</Text>
                <Spacer />
                <Input disabled value={variantState?.qcStock || 0} />
              </Flex>
            </Col>
          </Col>
        </Row>
      </div>
    </Flex>
  );
};

export default StockVariantCard;
